/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Forward_Email_DescInputs */

const en_dialog_forward_email_desc = /** @type {(inputs: Dialog_Forward_Email_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send newsletters or long emails to Listening and we'll automatically create an audio version.`)
};

const es_dialog_forward_email_desc = /** @type {(inputs: Dialog_Forward_Email_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía boletines o correos largos a Listening y crearemos automáticamente una versión en audio.`)
};

/**
* | output |
* | --- |
* | "Send newsletters or long emails to Listening and we'll automatically create an audio version." |
*
* @param {Dialog_Forward_Email_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_forward_email_desc = /** @type {((inputs?: Dialog_Forward_Email_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Forward_Email_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_forward_email_desc(inputs)
	return en_dialog_forward_email_desc(inputs)
});